export default {
  'nav.catalog': 'Catalog', 'nav.live': 'Live Classes', 'nav.qa': 'Ask an Expert',
  'nav.consult': 'Consultation', 'nav.providers': 'Providers', 'nav.myLearning': 'My Learning',
  'nav.certificates': 'Certificates', 'nav.orders': 'Orders', 'nav.bookings': 'My Schedule',
  'nav.admin': 'Admin Portal', 'nav.verify': 'Verify Certificate',
  'auth.login': 'Sign in', 'auth.loginWith': 'Sign in with The Muslim', 'auth.logout': 'Sign out',
  'auth.subtitle': 'Use your The Muslim account — no separate signup.',
  'auth.ssoContinue': 'Continue with The Muslim',
  'auth.ssoHint': "You'll be taken to The Muslim. No account yet? You can sign up there.",
  'auth.cbWorking': 'Finishing sign-in…',
  'auth.cbFailed': 'Sign-in did not complete',
  'auth.cbMissing': 'The return link is incomplete. Please sign in again.',
  'auth.cbHome': 'Go home',
  'hero.eyebrow': 'Connecting everyday people with credible experts',
  'hero.title': 'Learn straight from verified experts',
  'hero.sub': 'Structured e-courses, live classes, expert Q&A and private consultations — one place, one account.',
  'hero.cta': 'Browse catalog', 'hero.cta2': 'See free classes',
  'stat.learners': 'learners', 'stat.courses': 'published courses', 'stat.experts': 'verified experts', 'stat.certificates': 'certificates issued',
  'home.categories': 'Browse by field', 'home.popular': 'Most popular', 'home.featured': 'Curator’s picks',
  'home.free': 'Start free', 'home.providers': 'Partner providers', 'home.experts': 'Verified experts',
  'home.live': 'Live & upcoming', 'home.seeAll': 'See all',
  'home.trust1': 'Verified experts', 'home.trust1d': 'Every expert passes credential verification before joining.',
  'home.trust2': 'Easy access', 'home.trust2d': 'Ask the right specialist directly, without friction.',
  'home.trust3': 'Answers you can trust', 'home.trust3d': 'Guidance from specialists in the field, not just opinion.',
  'catalog.title': 'Course catalog', 'catalog.filters': 'Filters', 'catalog.reset': 'Reset',
  'catalog.results': 'courses found', 'catalog.sort': 'Sort', 'catalog.search': 'Search courses, experts or topics',
  'filter.category': 'Field', 'filter.level': 'Level', 'filter.price': 'Price', 'filter.rating': 'Rating',
  'filter.language': 'Language', 'filter.features': 'Features', 'filter.provider': 'Provider',
  'level.beginner': 'Beginner', 'level.intermediate': 'Intermediate', 'level.advanced': 'Advanced', 'level.expert': 'Advanced', 'level.all': 'All levels',
  'price.free': 'Free', 'price.paid': 'Paid', 'sort.most_popular': 'Most popular',
  'sort.highest_rated': 'Highest rated', 'sort.newest': 'Newest', 'sort.price_low': 'Lowest price', 'sort.price_high': 'Highest price',
  'feat.certificate': 'Certificate', 'feat.quiz': 'Quizzes', 'feat.live': 'Live sessions',
  'course.enroll': 'Enroll now', 'course.enrollFree': 'Join for free', 'course.continue': 'Continue learning',
  'course.buy': 'Buy course', 'course.preview': 'Free preview', 'course.objectives': 'What you’ll master',
  'course.curriculum': 'Curriculum', 'course.requirements': 'What you’ll need', 'course.audience': 'Who it’s for',
  'course.about': 'About this course', 'course.instructor': 'Instructor', 'course.reviews': 'Reviews',
  'course.related': 'Similar courses', 'course.lessons': 'lessons', 'course.modules': 'modules',
  'course.includes': 'Includes', 'course.lifetime': 'Lifetime access', 'course.expiry': '{n}-day access',
  'course.enrolled': '{n} learners', 'course.lastUpdate': 'Updated {d}', 'course.locked': 'Locked',
  'checkout.title': 'Order summary', 'checkout.coupon': 'Coupon code', 'checkout.apply': 'Apply',
  'checkout.pay': 'Pay now', 'checkout.method': 'Payment method', 'checkout.total': 'Total',
  'checkout.subtotal': 'Subtotal', 'checkout.discount': 'Discount', 'checkout.simulate': 'Midtrans Snap simulation',
  'checkout.success': 'Payment successful', 'checkout.startLearning': 'Start learning',
  'learn.title': 'My Learning', 'learn.inProgress': 'In progress', 'learn.completed': 'Completed',
  'learn.notStarted': 'Not started', 'learn.resume': 'Resume', 'learn.progress': '{n}% complete',
  'player.next': 'Next lesson', 'player.prev': 'Previous', 'player.complete': 'Mark complete',
  'player.previewNote': 'You are watching a free sample of this course. The rest unlocks after you enrol.', 'player.previewCta': 'View course', 'player.otherLang': 'Video is in {lang}',
  'player.notes': 'Notes', 'player.resources': 'Resources', 'player.transcript': 'Transcript', 'player.discussion': 'Discussion',
  'player.speed': 'Speed', 'player.captions': 'Captions', 'player.resume': 'Resume from {t}',
  // --- learning space (/learn) ---
  'player.exit': 'Exit', 'player.lessonOf': 'Lesson {n} of {total}',
  'player.remaining': '{t} left', 'player.shortcutHint': 'space pause · ←→ 5s · J/L 10s · F fullscreen',
  'player.videoMissing': 'This lesson has no video yet.',
  'player.videoBroken': 'The video exists, but its link could not be created. Try reloading the page.',
  'player.tamper': 'The owner watermark was removed, so playback stopped. Reload the page to watch again.',
  'player.throttled': 'Too many video requests from this account within one hour. Please try again shortly.',
  'player.linkDead': 'The video link could not be renewed. Check your connection, then reload the page.',
  'player.nextUp': 'Up next', 'player.lastLesson': 'This is the last lesson.', 'player.replay': 'Replay',
  'player.markedDone': 'Lesson marked complete',
  'player.liveNote': 'Live session for enrolled students. The link opens 10 minutes before the schedule.',
  'player.liveCta': 'See live schedule',
  'player.noteAdd': 'Save note', 'player.notePlaceholder': 'Write your note for this lesson…',
  'player.notePlaceholderAt': 'Write a note for {t}…',
  'player.notesEmpty': 'No notes yet. What you write here is saved to your account, so it is still there on another device.',
  'player.notesLoginTitle': 'Notes are saved to your account',
  'player.notesLoginHint': 'Sign in first so your notes survive a change of device.',
  'player.jumpTo': 'Jump to this moment',
  'player.resourcesEmpty': 'No downloads attached to this lesson.',
  'player.download': 'Download', 'player.linkFailed': 'Link failed',
  'player.courseDone': 'Course complete! 🎉',
  'player.courseDoneNote': 'Your certificate has been issued and can be verified publicly with its unique code.',
  'player.viewCert': 'View certificate',
  'ui.edit': 'Edit', 'ui.delete': 'Delete',
  'adm.res.title': 'Downloads', 'adm.res.add': 'Add file',
  'adm.res.added': 'File attached',
  'adm.res.tooBig': 'Maximum file size is 25 MB.',
  'adm.res.hint': 'Attach slides, worksheets, or a summary. PDF or image, up to 25 MB. Export slides to PDF first.',
  'quiz.start': 'Start quiz', 'quiz.submit': 'Submit', 'quiz.retry': 'Try again',
  'quiz.passed': 'Passed', 'quiz.failed': 'Not passed yet', 'quiz.score': 'Score', 'quiz.attempt': 'Attempt {n}',
  'cert.title': 'My Certificates', 'cert.download': 'Download PDF', 'cert.share': 'Share on LinkedIn',
  'cert.verify': 'Verify', 'cert.serial': 'Serial number', 'cert.issued': 'Issued',
  'cert.valid': 'This certificate is valid and on record', 'cert.invalid': 'Certificate not found',
  'cert.verifyTitle': 'Verify a certificate', 'cert.verifyHint': 'Enter the verification code printed on the certificate',
  'qa.title': 'Ask an Expert', 'qa.ask': 'Ask a question', 'qa.answered': 'Answered', 'qa.open': 'Awaiting answer',
  'qa.yourQuestion': 'Your question', 'qa.detail': 'Question detail', 'qa.send': 'Send question',
  'qa.sub': 'Send a question to a verified expert. Free in v1 — answers are public so others benefit too.',
  'qa.field': 'Field', 'qa.askWho': 'Ask who', 'qa.anyExpert': 'Any expert in this field',
  'qa.askWhoHint': 'Leave empty if not aimed at anyone in particular — open questions are usually answered faster.',
  'qa.field.title': 'Short question', 'qa.field.titlePh': 'Example: What is the ruling on…?',
  'qa.field.body': 'Details', 'qa.field.bodyHint': 'The more detail, the more precise the answer',
  'qa.publicNote': 'Answered questions appear publicly, without your personal data.',
  'qa.sent': 'Question sent — an expert will answer within 1–3 working days.',
  'live.title': 'Live Classes', 'live.now': 'Live now', 'live.upcoming': 'Upcoming', 'live.ended': 'Ended',
  'live.join': 'Join class', 'live.remind': 'Remind me', 'live.reminded': 'Reminder on', 'live.viewers': '{n} watching',
  'consult.title': '1-on-1 Consultation', 'consult.book': 'Pick a slot', 'consult.slots': '{n} slots open',
  'consult.from': 'From', 'consult.confirm': 'Confirm booking', 'consult.notes': 'Briefly describe what you need',
  'admin.dashboard': 'Dashboard', 'admin.guide': 'Guide', 'admin.courses': 'Courses', 'admin.instructors': 'Instructors',
  'admin.live': 'Live Classes', 'admin.qa': 'Q&A', 'admin.consult': 'Consultations',
  'admin.enrollments': 'Enrollments', 'admin.reviews': 'Reviews', 'admin.earnings': 'Earnings',
  'admin.slots': 'Consultation Slots', 'admin.certificates': 'Certificates', 'admin.coupons': 'Coupons',
  'admin.notifications': 'Notifications', 'admin.certTemplates': 'Certificate Templates', 'admin.audit': 'Audit Log',
  'admin.providers': 'Providers', 'admin.categories': 'Categories', 'admin.payouts': 'Payouts',
  'admin.platformOnly': 'Platform only', 'admin.approvalQueue': 'Awaiting review',
  'admin.selected': '{n} selected', 'admin.approve': 'Approve', 'admin.reject': 'Reject', 'admin.archive': 'Archive',
  'admin.bulk': 'Bulk actions', 'admin.newCourse': 'New course', 'admin.editCurriculum': 'Edit curriculum',
  'status.draft': 'Draft', 'status.pending_review': 'Pending review', 'status.published': 'Published',
  'status.rejected': 'Rejected', 'status.archived': 'Archived', 'status.active': 'Active', 'status.completed': 'Completed',
  'status.paid': 'Paid', 'status.pending': 'Pending', 'status.failed': 'Failed', 'status.held': 'Held',
  'status.payable': 'Payable', 'status.processing': 'Processing',
  'ui.loading': 'Loading…', 'ui.retry': 'Retry', 'ui.error': 'Something went wrong',
  'ui.empty': 'Nothing here yet', 'ui.emptyHint': 'Try changing filters or keywords.',
  'ui.save': 'Save', 'ui.cancel': 'Cancel', 'ui.close': 'Close', 'ui.search': 'Search',
  'ui.all': 'All', 'ui.verified': 'Verified', 'ui.comingSoon': 'Coming Soon',
  'ui.page': 'Page', 'ui.of': 'of', 'ui.viewMode': 'View', 'ui.design': 'Design variant',

  // ---- admin portal: labels shared across pages ----
  // Collected here so the "Status"/"Instructor"/"Price" columns that show up in
  // a dozen tables do not become a dozen keys to translate one by one.
  'adm.col.actions': 'Actions', 'adm.col.provider': 'Provider', 'adm.col.instructor': 'Instructor',
  'adm.col.status': 'Status', 'adm.col.price': 'Price', 'adm.col.students': 'Learners',
  'adm.col.no': 'No.',
  'adm.col.course': 'Course', 'adm.col.schedule': 'Schedule', 'adm.col.time': 'Time',
  'adm.col.duration': 'Duration', 'adm.col.field': 'Field', 'adm.col.updated': 'Updated',
  'adm.col.notes': 'Notes', 'adm.col.position': 'Order', 'adm.col.key': 'Key',
  'adm.col.score': 'Score', 'adm.col.scope': 'Scope',
  'adm.table.clear': 'clear',
  'adm.val.inactive': 'Inactive', 'adm.val.platform': 'Platform', 'adm.val.default': 'Default',
  'adm.val.pending': 'Pending', 'adm.val.notYet': 'Not yet', 'adm.val.yes': 'Yes',
  'adm.val.minutes': '{n} min',
  'adm.lang.id': 'Indonesian', 'adm.lang.en': 'English', 'adm.lang.ms': 'Malay', 'adm.lang.ar': 'Arabic',
  'adm.field.category': 'Category', 'adm.field.priceIdr': 'Price (IDR)', 'adm.field.logo': 'Logo',
  'adm.field.accentColor': 'Accent colour (hex)',
  'adm.field.providerHint': 'Provider admins automatically use their own institution.',
  'adm.bulk.activate': 'Activate', 'adm.bulk.deactivate': 'Deactivate',
  'adm.bulk.markComplete': 'Mark complete', 'adm.bulk.approvePublish': 'Approve & publish',
  'adm.bulk.unpublish': 'Unpublish',
  'adm.bulk.updated': '{n} rows updated', 'adm.bulk.rejected': '{n} rows rejected',
  'adm.filter.all': '{field}: All',

  // ---- admin portal: generic form (ResourcePage) ----
  'adm.form.required': '{field} is required', 'adm.form.selectField': '— Select {field} —',
  'adm.form.optionsFailed': 'Could not load options', 'adm.form.saved': 'Changes saved',
  'adm.form.created': 'Added', 'adm.form.saveFailed': 'Could not save',
  'adm.form.deleted': 'Record deleted', 'adm.form.deleteFailed': 'Could not delete',
  'adm.form.edit': 'Edit', 'adm.form.add': 'Add', 'adm.form.delete': 'Delete',
  'adm.form.deleteTitle': 'Confirm delete',
  'adm.form.deleteDefault': 'Delete this record? It can be undone in the DB (soft delete).',
  'adm.reject.title': 'Reason for rejection', 'adm.reject.confirmN': 'Reject {n} courses',
  'adm.reject.note': 'The reason is sent to the provider and shown in their portal. Explain what needs fixing.',
  'adm.reject.ph': 'e.g. the audio in module 2 breaks up at 04:12 — please re-record.',

  // ---- admin portal: courses ----
  'adm.courses.sub': 'Curate, publish, and manage course curriculum.',
  'adm.courses.add': 'New course', 'adm.courses.createTitle': 'New Course',
  'adm.courses.createdMsg': 'Course created as a draft — complete the curriculum, then submit for review.',
  'adm.courses.formSub': 'Create the course shell first (draft status). Curriculum, modules, quizzes & detailed pricing are set in the course editor.',
  'adm.courses.newCourseToast': 'New course form: POST /admin/courses',
  'adm.courses.field.title': 'Course title', 'adm.courses.field.titlePh': 'e.g. Tahsin Al-Qur’an for Beginners',
  'adm.courses.field.subtitle': 'Subtitle', 'adm.courses.field.subtitlePh': 'Shown on the card & hero',
  'adm.courses.field.instructor': 'Instructor',
  'adm.courses.field.instructorHint': 'Must be an instructor from the same provider.',
  'adm.courses.field.categoryHint': 'Leave empty to follow the instructor’s field.',
  'adm.courses.field.isFree': 'Free course',
  'adm.courses.field.minutes': 'Estimated duration (minutes)',
  'adm.courses.field.desc': 'Short description', 'adm.courses.field.descPh': 'Summarise the content & what learners gain…',
  'adm.courses.lessonModules': '{l} lessons · {m} modules',
  'adm.courses.manage': 'Manage',

  // ---- admin portal: instructors ----
  'adm.instructors.sub': 'Verify instructor credentials — the platform’s core value.',
  'adm.instructors.add': 'New instructor', 'adm.instructors.createTitle': 'New Instructor',
  'adm.instructors.editTitle': 'Edit Instructor',
  'adm.instructors.formSub': 'Fill in the instructor profile. Field and provider decide where they appear.',
  'adm.instructors.deleteConfirm': 'Delete instructor "{name}"? The record is hidden (soft delete) and can be restored in the DB.',
  'adm.instructors.field.avatar': 'Profile photo',
  'adm.instructors.field.name': 'Full name', 'adm.instructors.field.namePh': 'e.g. Ustadz Ahmad Fauzi, Lc.',
  'adm.instructors.field.headline': 'Headline', 'adm.instructors.field.headlinePh': 'Expert in Tajweed & Qiraat Sab’ah',
  'adm.instructors.field.category': 'Field of expertise',
  'adm.instructors.field.bio': 'Short bio',
  'adm.instructors.field.bioPh': 'Background, teaching experience, and how they approach the material…',
  'adm.instructors.field.verified': 'Mark as verified',
  'adm.instructors.filterVerified': 'Verification', 'adm.instructors.unverify': 'Revoke verification',
  'adm.i18n.sectionTitle': 'Text in several languages',
  'adm.i18n.sectionHint': 'Only the fields in this box have a version per language. The photo, name and fields above exist once.',
  'adm.i18n.sourceLang': 'Language you wrote in',
  'adm.i18n.sourceHint': 'The language used in the fields below. Translations are made from this, so make sure it is right.',
  'adm.i18n.sourceBadge': '(original)',
  'adm.i18n.translate': 'Translate with AI',
  'adm.i18n.saveFirst': 'Save first, then translate.',
  'adm.i18n.translateTo': 'Translate to {lang} with AI',
  'adm.i18n.pickTab': 'Pick a target language tab first.',
  'adm.i18n.done': 'Translation finished.',
  'adm.i18n.failed': 'Translation failed. Try again shortly.',
  'adm.i18n.partial': 'Some languages failed. Try again for the ones still empty.',
  'adm.i18n.nothing': 'Nothing to translate — everything is already filled in.',
  'adm.i18n.fromAI': 'Machine translation — please review and correct if needed.',
  'adm.i18n.edited': 'Edited by hand. Will not be overwritten by re-translation.',
  'adm.i18n.empty': 'Not translated yet. Empty means the original text is shown.',
  'adm.instructors.field.accountEmail': 'Login account (email)',
  'adm.instructors.field.accountEmailPh': 'address@campus.edu.my',
  'adm.instructors.account.hintNew': 'Fill this in to create an account. The expert then registers at The Muslim with the same address.',
  'adm.instructors.account.hintNone': 'No account yet — this expert cannot sign in. Enter an email to create one.',
  'adm.instructors.account.hintWaiting': 'Account created. The expert now registers at The Muslim with this address and verifies the email.',
  'adm.instructors.account.hintLinked': 'Has signed in. Clearing this field does not unlink anything.',
  'adm.instructors.account.hintMissing': 'Dangling link: the account no longer exists. Enter a new email to reconnect.',
  'adm.instructors.col.account': 'Account',
  'adm.instructors.account.none': 'No account',
  'adm.instructors.account.waiting': 'Awaiting sign-up',
  'adm.instructors.account.linked': 'Active',
  'adm.instructors.account.missing': 'Broken link',
  'adm.instructors.col.credentials': 'Credentials',

  // ---- admin portal: live classes ----
  'adm.live.sub': 'Schedule LiveKit sessions, track viewers.',
  'adm.live.col.session': 'Session', 'adm.live.col.viewers': 'Viewers',
  'adm.live.col.ticket': 'Ticket', 'adm.live.col.room': 'Room',

  // ---- admin portal: ask an expert ----
  'adm.qa.sub': 'Queue of questions waiting for an expert answer.',
  'adm.qa.col.question': 'Question', 'adm.qa.col.addressed': 'Addressed to',
  'adm.qa.col.received': 'Received', 'adm.qa.col.answers': 'Answers',
  'adm.qa.answerTitle': 'Answer question', 'adm.qa.answerSend': 'Send answer',
  'adm.qa.answerSent': 'Answer sent', 'adm.qa.answerLabel': 'Expert answer',
  'adm.qa.answerPh': 'Write the answer with references that can be verified…',
  'adm.qa.answerNote': 'The answer goes public straight away and notifies the person who asked.',

  // ---- admin portal: consultations & enrollments ----
  'adm.consult.sub': '1-on-1 session bookings and their status.',
  'adm.consult.confirm': 'Confirm', 'adm.consult.cancel': 'Cancel',
  'adm.enroll.sub': 'Who is learning what, and how far they have got.',
  'adm.enroll.reactivate': 'Reactivate', 'adm.enroll.revoke': 'Revoke access',
  'adm.enroll.col.source': 'Source', 'adm.enroll.col.progress': 'Progress',
  'adm.enroll.col.enrolledAt': 'Enrolled',

  // ---- admin portal: reviews ----
  'adm.reviews.sub': 'Moderate reviews; hide the ones that break the rules.',
  'adm.reviews.filterStars': 'Stars', 'adm.reviews.hide': 'Hide', 'adm.reviews.show': 'Show',
  'adm.reviews.col.author': 'Author', 'adm.reviews.col.text': 'Review',

  // ---- admin portal: providers ----
  'adm.providers.sub': 'Tenants that sell courses. Platform only.',
  'adm.providers.add': 'New provider', 'adm.providers.createTitle': 'New Provider',
  'adm.providers.editTitle': 'Edit Provider',
  'adm.providers.formSub': 'Onboard a new institution or company as a course seller. The slug is generated from the name.',
  'adm.providers.field.cover': 'Cover',
  'adm.providers.field.name': 'Provider name', 'adm.providers.field.namePh': 'e.g. Rumah Tahfizh Nusantara',
  'adm.providers.field.desc': 'Description', 'adm.providers.field.descPh': 'Short profile of the institution…',
  'adm.providers.field.website': 'Website', 'adm.providers.field.email': 'Contact email',
  'adm.providers.field.emailPh': 'admin@lembaga.id',
  'adm.providers.field.share': 'Provider revenue share (%)',
  'adm.providers.field.shareHint': 'The provider’s cut of the price; the rest goes to the platform.',
  'adm.providers.field.locale': 'Default locale',
  'adm.providers.verify': 'Verify',
  'adm.providers.col.share': 'Revenue share', 'adm.providers.col.locale': 'Locale',

  // ---- admin portal: categories ----
  'adm.categories.sub': 'Platform-level taxonomy (15 fields).',
  'adm.categories.add': 'New category', 'adm.categories.editTitle': 'Edit Category',
  'adm.categories.formSub': 'Platform fields of expertise. The key is used in URLs & filters — leave it empty to generate one from the name.',
  'adm.categories.deleteConfirm': 'Delete category "{name}"? It will be hidden (soft delete).',
  'adm.categories.field.nameId': 'Name (Indonesian)', 'adm.categories.field.nameIdPh': 'e.g. Tahsin & Tajwid',
  'adm.categories.field.nameEn': 'Name (English)', 'adm.categories.field.nameMs': 'Name (Malay)',
  'adm.categories.field.nameAr': 'Name (Arabic)',
  'adm.categories.field.keyPh': 'tahsin-tajwid (optional)',
  'adm.categories.field.keyHint': 'Unique slug; generated from the name if left empty.',
  'adm.categories.field.icon': 'Icon (Material Symbols)',
  'adm.categories.col.accent': 'Accent',
  // ---- admin portal: payouts ----
  'adm.payouts.sub': 'Revenue-share transfers to providers, per period.',
  'adm.payouts.markPaid': 'Mark as paid',
  'adm.payouts.col.period': 'Period', 'adm.payouts.col.amount': 'Amount', 'adm.payouts.col.method': 'Method',

  // ---- admin portal: coupons ----
  'adm.coupons.sub': 'Discount codes: percentage / fixed amount, usage limits, and validity.',
  'adm.coupons.add': 'New coupon', 'adm.coupons.editTitle': 'Edit Coupon',
  'adm.coupons.formSub': 'The code is uppercased automatically. Value = percent (0–100) for the percentage type, or rupiah for a fixed amount.',
  'adm.coupons.deleteConfirm': 'Delete coupon "{code}"? It will be hidden (soft delete).',
  'adm.coupons.field.code': 'Coupon code', 'adm.coupons.field.type': 'Type',
  'adm.coupons.type.percent': 'Percentage (%)', 'adm.coupons.type.fixed': 'Fixed amount (Rp)',
  'adm.coupons.field.value': 'Value',
  'adm.coupons.scope.all': 'All courses', 'adm.coupons.scope.course': 'Specific course',
  'adm.coupons.scope.category': 'Specific category',
  'adm.coupons.field.maxUses': 'Max total uses', 'adm.coupons.field.maxUsesHint': '0 = unlimited.',
  'adm.coupons.field.perUser': 'Max per user',
  'adm.coupons.field.startsAt': 'Starts', 'adm.coupons.field.endsAt': 'Ends',
  'adm.coupons.field.providerHint': 'Leave empty for a platform-wide coupon.',
  'adm.coupons.col.code': 'Code', 'adm.coupons.col.discount': 'Discount',
  'adm.coupons.col.used': 'Used', 'adm.coupons.col.valid': 'Valid',

  // ---- admin portal: consultation slots ----
  'adm.slots.sub': 'Time slots for 1-on-1 consultations that instructors open for booking.',
  'adm.slots.add': 'New slot', 'adm.slots.createTitle': 'Open Consultation Slot',
  'adm.slots.editTitle': 'Edit Slot',
  'adm.slots.formSub': 'A slot follows the instructor’s provider. Slots that are already booked cannot be reopened here.',
  'adm.slots.deleteConfirm': 'Delete this slot? It will be hidden (soft delete).',
  'adm.slots.field.start': 'Start time', 'adm.slots.field.duration': 'Duration (minutes)',
  'adm.slots.field.priceHint': '0 = free.',
  'adm.slots.open': 'Open', 'adm.slots.col.booked': 'Booking',
  'adm.slots.booked': 'Booked', 'adm.slots.free': 'Available',

  // ---- admin portal: certificates ----
  'adm.certs.sub': 'Certificates already issued; revoke or reissue them if needed.',
  'adm.certs.reissue': 'Reissue', 'adm.certs.revoke': 'Revoke',
  'adm.certs.col.issued': 'Issued', 'adm.certs.col.code': 'Verification code',
  'adm.certTpl.sub': 'Certificate design: logo, colours, signature, and body text.',
  'adm.certTpl.add': 'New template', 'adm.certTpl.createTitle': 'New Certificate Template',
  'adm.certTpl.editTitle': 'Edit Template',
  'adm.certTpl.formSub': 'Use {student}, {course}, {date} in the body text as placeholders that are replaced when the certificate is issued.',
  'adm.certTpl.deleteConfirm': 'Delete template "{name}"? It will be hidden (soft delete).',
  'adm.certTpl.field.name': 'Template name', 'adm.certTpl.field.namePh': 'e.g. Tahsin Certificate 2026',
  'adm.certTpl.field.providerHint': 'Leave empty for a platform template.',
  'adm.certTpl.field.orientation': 'Orientation',
  'adm.certTpl.orientation.landscape': 'Landscape', 'adm.certTpl.orientation.portrait': 'Portrait',
  'adm.certTpl.field.signature': 'Signature',
  'adm.certTpl.field.signName': 'Signatory name', 'adm.certTpl.field.signTitle': 'Signatory title',
  'adm.certTpl.field.signNamePh': 'Ustadz Ahmad Fauzi, Lc.',
  'adm.certTpl.field.signTitlePh': 'Academic Director',
  'adm.certTpl.field.body': 'Body text',
  'adm.certTpl.field.bodyPh': 'Awarded to {student} for completing {course}…',
  'adm.certTpl.field.isDefault': 'Set as default',
  'adm.certTpl.col.template': 'Template', 'adm.certTpl.col.signer': 'Signatory',

  // ---- admin portal: audit log ----
  'adm.audit.sub': 'Trail of admin actions (create/update/delete/broadcast). Source: activity log.',
  'adm.audit.col.action': 'Action', 'adm.audit.col.actor': 'By', 'adm.audit.col.detail': 'Detail',

  // ---- course editor ----
  'adm.course.tabDetail': 'Detail', 'adm.course.tabPricing': 'Pricing & access',
  'adm.course.tabSettings': 'Certificate',
  'adm.course.viewPublic': 'View public page', 'adm.course.preview': 'Preview content', 'adm.course.previewEmpty': 'No lesson to preview yet', 'adm.course.submitReview': 'Submit for review',
  'adm.course.published': 'Course published', 'adm.course.rejected': 'Course rejected',
  'adm.course.rejectedBy': 'Rejected by curator', 'adm.course.rejectBtn': 'Reject course',
  'adm.course.rejectPh': 'Explain what the provider needs to fix…',
  'adm.course.title': 'Title', 'adm.course.estMinutes': 'Estimated minutes',
  'adm.course.spokenLang': 'Spoken language',
  'adm.course.spokenLangHint': 'The language the teacher speaks in the videos. Not translated.',
  'adm.course.descHtml': 'Description (HTML)', 'adm.course.objectives': 'Objectives',
  'adm.course.addObjective': 'Add point',
  'adm.course.objectivesHint': 'What students can do once they finish.',
  'adm.course.objectivesPh': 'Example: Design a counselling session plan for teenage clients',
  'adm.course.addRequirement': 'Add item',
  'adm.course.requirementsHint': 'Things students should have ready. This does not lock the course — the lock is the Prerequisite field just below.',
  'adm.course.requirementsPh': 'Example: Has taken a basic counselling course',
  'adm.course.addAudience': 'Add audience',
  'adm.course.audienceHint': 'Who this course fits best.',
  'adm.course.audiencePh': 'Example: School guidance counsellors',
  'adm.course.thumbnail': 'Thumbnail', 'adm.course.thumbHint': 'Ratio 16:9, minimum 1280×720, max 8 MB.',
  'adm.course.slug': 'Slug', 'adm.course.comparePrice': 'Compare-at price',
  'adm.course.accessType': 'Access type', 'adm.course.access.lifetime': 'Lifetime',
  'adm.course.access.expiry': 'Expires after N days', 'adm.course.access.subscription': 'Subscription',
  'adm.course.accessDays': 'Access (days)',
  'adm.course.certOnComplete': 'Issue certificate on completion',
  'adm.course.completionRule': 'Completion rule',
  'adm.course.completionRule1': '100% of lessons completed · final quiz passed (score ≥ 70)',
  'adm.course.completionRule2': 'A video counts as completed at 90% of its duration (SCORM/cmi5: completion ≠ success).',

  // ---- course editor: readiness ----
  'adm.ready.title': 'Course readiness', 'adm.ready.count': '{n}/{total} ready',
  'adm.ready.live': 'This course is live on the storefront.',
  'adm.ready.waiting': 'Waiting for platform admin review',
  'adm.ready.remaining': '{n} steps left to complete',
  'adm.ready.detail': 'Course detail', 'adm.ready.detailDone': 'Description & objectives complete',
  'adm.ready.detailTodo': 'Fill in the description + at least 1 objective',
  'adm.ready.curriculum': 'Curriculum',
  'adm.ready.curriculumTodo': 'Add at least 1 module & 1 lesson',
  'adm.ready.quiz': 'Quiz questions', 'adm.ready.quizDone': 'Every quiz has its questions',
  'adm.ready.quizTodo': '{n} quizzes have no questions',
  'adm.ready.priceTodo': 'Set a price or mark it free',

  // ---- curriculum editor ----
  'adm.cur.loading': 'Loading curriculum…', 'adm.cur.saved': 'Curriculum saved',
  'adm.cur.addModule': 'Add module', 'adm.cur.addLesson': 'Add lesson',
  'adm.cur.moduleN': 'Module {n}', 'adm.cur.newLesson': 'New lesson',
  'adm.cur.count': '{m} modules · {l} lessons',
  'adm.cur.unsaved': 'Unsaved', 'adm.cur.save': 'Save curriculum',
  'adm.cur.drip.none': 'Release: immediately', 'adm.cur.drip.days': 'Release: after N days', 'adm.cur.drip.date': 'Release: on a date',
  'adm.cur.seconds': 'seconds', 'adm.cur.preview': 'preview',
  'adm.cur.saveFirst': 'save first',
  'adm.cur.saveFirstHint': 'Save the curriculum first so the lesson gets an ID',
  'adm.a11y.moveUp': 'move up', 'adm.a11y.moveDown': 'move down', 'adm.a11y.delete': 'delete',

  // ---- quiz editor ----
  'adm.quiz.title': 'Manage questions · {lesson}', 'adm.quiz.save': 'Save quiz', 'adm.quiz.saved': 'Quiz saved',
  'adm.quiz.passing': 'Pass score (%)', 'adm.quiz.timeLimit': 'Time limit (minutes)',
  'adm.quiz.maxAttempts': 'Max attempts',
  'adm.quiz.question': 'Questions', 'adm.quiz.questionPh': 'Write the question…',
  'adm.quiz.deleteQuestion': 'delete question', 'adm.quiz.deleteOption': 'delete option',
  'adm.quiz.type': 'Type', 'adm.quiz.points': 'Points',
  'adm.quiz.qtype.single': 'Single choice', 'adm.quiz.qtype.multi': 'Multiple choice (more than 1 correct allowed)',
  'adm.quiz.qtype.tf': 'True / False',
  'adm.quiz.options': 'Answer options', 'adm.quiz.optionsHint': '(tick the correct ones)',
  'adm.quiz.markCorrect': 'mark correct', 'adm.quiz.optionN': 'Option {n}', 'adm.quiz.addOption': 'Add option',
  'adm.quiz.explanation': 'Explanation (optional)', 'adm.quiz.explanationPh': 'Shown after the learner answers',
  'adm.quiz.addQuestion': 'Add question', 'adm.quiz.empty': 'No questions yet. Click “Add question”.',
  'adm.quiz.err.noText': 'A question has no question text',
  'adm.quiz.err.minOptions': 'Every question needs at least 2 answer options',
  'adm.quiz.err.emptyOption': 'An answer option is empty',
  'adm.quiz.err.noCorrect': 'Every question needs at least 1 correct answer',

  // ---- admin dashboard ----
  'adm.dash.period': 'Period {label}.', 'adm.dash.loading': 'Loading summary…', 'adm.dash.export': 'Export',
  'adm.dash.guideTitle': 'New here? Start with the guide.',
  'adm.dash.guideSub': 'The order to fill content in, the fields that are required, and the traps that make courses fail review.',
  'adm.dash.guideCta': 'Open the guide',
  'adm.dash.enrollments': 'Enrollments',
  'adm.dash.lessonsDone': 'Lessons completed (North Star)', 'adm.dash.lessonsHint': 'Indicator of real learning value',
  'adm.dash.certsIssued': 'Certificates issued',
  'adm.dash.funnelTitle': 'Purchase funnel', 'adm.dash.funnelRange': '{first} → paid',
  'adm.dash.funnelConversion': 'Final conversion',
  'adm.dash.funnelNoVisits': 'No visits were recorded this month, so the conversion percentage cannot be calculated yet. Recording runs automatically as soon as a visitor opens the catalog.',
  'adm.dash.funnelEmpty': 'No catalog visits this month yet. Visits start being recorded as soon as someone opens a course page — admin visits are deliberately not counted.',
  'adm.dash.queueAll': 'All queues', 'adm.dash.queueClean': 'Queue is clear 🎉',
  'adm.dash.submitted': 'Submitted {ago}', 'adm.dash.lessonCount': '{n} lessons', 'adm.dash.reviewCta': 'Review',
  'adm.dash.topCourses': 'Best-selling courses', 'adm.dash.enrollCount': '{n} enrollments',
  'adm.dash.topCoursesEmpty': 'No course has any enrollments yet. This list fills itself as soon as someone joins the first course.',
  'adm.dash.health': 'Platform health', 'adm.dash.payoutsWaiting': 'Payouts waiting',
  'adm.dash.reviewsToCheck': 'Reviews to check',
  'adm.dash.recentOrders': 'Recent orders', 'adm.dash.orderNoItems': '(no item details)',
  'adm.dash.ordersEmpty': 'No orders yet.',
  'adm.dash.csv.metric': 'Metric', 'adm.dash.csv.value': 'Value', 'adm.dash.csv.period': 'Period',
  'adm.dash.csv.gmv': 'GMV', 'adm.dash.csv.lessonsDone': 'Lessons completed',
  'adm.dash.csv.month': 'Month', 'adm.dash.csv.funnelStage': 'Funnel stage',
  'adm.dash.csv.count': 'Count', 'adm.dash.csv.revenue': 'Revenue',

  // ---- admin portal shell ----
  'adm.gate.title': 'KnowledgeX Admin Portal',
  'adm.gate.sub': 'Sign in with a platform admin or provider admin account, using the email & password the technical team gave you.',
  'adm.gate.login': 'Sign in as admin', 'adm.gate.storefront': 'Go to storefront',
  'adm.role.platform': 'Platform admin', 'adm.role.provider': 'Provider admin',
  'adm.scope.all': 'All providers', 'adm.scope.provider': 'Scope: {name}',
  'adm.nav.storefront': 'Storefront',

  // ---- onboarding checklist ----
  'adm.onb.fabTitle': 'First steps for new instructors', 'adm.onb.fabLabel': 'First steps — {n} steps left',
  'adm.onb.fabTip': 'First steps',
  'adm.onb.panelTitle': 'Start here', 'adm.onb.checking': 'Checking…',
  'adm.onb.progress': '{n} of {total} done',
  'adm.onb.doneTitle': 'All steps done 🎉',
  'adm.onb.donePlatform': 'The catalog now has a course live.',
  'adm.onb.doneProvider': 'Your course has reached the review stage.',
  'adm.onb.doneTail': 'The full guide stays available any time from the menu',
  'adm.onb.doneClose': 'Done, close this list', 'adm.onb.doneLater': 'Later',
  'adm.onb.hideForever': 'Hide for good',
  'adm.onb.step.guide': 'Read the short guide', 'adm.onb.step.guideDone': 'Already opened',
  'adm.onb.step.guideTodo': 'Includes a screenshot of every step',
  'adm.onb.step.instructor': 'Add an instructor',
  'adm.onb.step.instructorDone': '{n} instructors registered',
  'adm.onb.step.instructorTodo': 'A course must have an instructor',
  'adm.onb.step.course': 'Create your first course', 'adm.onb.step.courseDone': '{n} courses created',
  'adm.onb.step.courseTodo': 'Start with the title & the instructor',
  'adm.onb.step.detail': 'Fill in detail & objectives', 'adm.onb.step.detailDone': 'Description & {n} objectives filled in',
  'adm.onb.step.syllabus': 'Build the curriculum', 'adm.onb.step.price': 'Set a price or make it free',
  'adm.onb.step.priceTodo': 'Set a price, or mark it free',
  'adm.onb.needCourse': 'Needs a course first',
  'adm.onb.step.curatePlatform': 'Review & publish courses',
  'adm.onb.curate.published': '{n} courses live in the catalog',
  'adm.onb.curate.waiting': '{n} courses waiting for review',
  'adm.onb.curate.none': 'No course is ready for review yet',
  'adm.onb.submit.published': 'A course is already live',
  'adm.onb.submit.waiting': 'Under review by a platform admin',
  'adm.onb.submit.todo': 'Send it to a platform admin once readiness is 4/4',

  // ---- earnings ----
  'adm.earn.col.order': 'Order', 'adm.earn.col.share': 'Share',
  'adm.earn.col.availableAt': 'Available',
  'adm.earn.paid': 'Paid out',

  // ---- notification broadcast ----
  'adm.bc.sub': 'Send an announcement or notification to a chosen audience. It appears in the user’s notification bell.',
  'adm.bc.audience': 'Audience', 'adm.bc.kind': 'Type',
  'adm.bc.aud.students': 'All learners', 'adm.bc.aud.providers': 'Provider admins',
  'adm.bc.aud.admins': 'Platform admins', 'adm.bc.aud.all': 'All users',
  'adm.bc.kind.announcement': 'Announcement', 'adm.bc.kind.promo': 'Promo', 'adm.bc.kind.system': 'System',
  'adm.bc.title': 'Title', 'adm.bc.titlePh': 'e.g. New course: Tahsin Level 2 is now live',
  'adm.bc.body': 'Message', 'adm.bc.bodyPh': 'Write a short, clear message…',
  'adm.bc.note': 'Sent immediately; it cannot be recalled.',
  'adm.bc.send': 'Send broadcast', 'adm.bc.sent': '{n} notifications sent',
  'adm.bc.failed': 'Could not send',
  'adm.bc.recent': 'Recent notifications',
  'adm.bc.col.body': 'Message', 'adm.bc.col.read': 'Read',

  /* ---- akun pakar, direktori pakar & skala kategori ---- */
  'nav.profile': 'Expert Profile',
  'nav.account': 'The Muslim Account', 'nav.language': 'Language',
  'nav.instructors': 'Experts',
  'acc.title': 'My Account',
  'acc.sub': 'Manage your public profile and account security.',
  'acc.tab.profile': 'Expert Profile',
  'acc.tab.security': 'Security',
  'acc.save': 'Save profile',
  'acc.saved': 'Profile saved',
  'acc.readonlyNote': 'Admin-managed. Contact your provider admin to change these.',
  'acc.noProfile': 'No expert profile linked to this account',
  'acc.noProfileHint': 'Ask your provider admin to link one.',
  'acc.field.avatar': 'Profile photo',
  'acc.field.headline': 'Headline',
  'acc.field.headlineHint': 'One line on your field of expertise. Max 160 characters.',
  'acc.field.bio': 'Bio',
  'acc.field.bioHint': 'Your background, research and experience. Max 4000 characters.',
  'acc.field.social': 'Links',
  'acc.field.socialHint': 'Must start with https://',
  'acc.social.linkedin': 'LinkedIn',
  'acc.social.web': 'Website',
  'acc.social.scholar': 'Google Scholar',
  'acc.social.youtube': 'YouTube',
  'acc.social.instagram': 'Instagram',
  'acc.social.x': 'X',
  'acc.field.credentials': 'Credentials',
  'acc.cred.title': 'Title',
  'acc.cred.issuer': 'Issuer / detail',
  'acc.cred.year': 'Year',
  'acc.cred.add': 'Add credential',
  'acc.cred.remove': 'Remove',
  'acc.cred.empty': 'No credentials yet.',
  'acc.readonly.name': 'Name',
  'acc.readonly.category': 'Field',
  'acc.readonly.provider': 'Provider',
  'acc.complete.title': 'Profile completeness',
  'acc.complete.sub': 'Complete every section so an admin can verify your profile.',
  'acc.complete.count': '{n} of {total} done',
  'acc.pw.title': 'Account security',
  'acc.pw.sub': 'Your password, email and name live at The Muslim — one account for every service.',
  'acc.pw.manage': 'Manage your The Muslim account',
  'acc.pw.unavailable': 'The Muslim account address is not configured on this server.',
  'adm.role.instructor': 'Expert',
  'adm.role.student': 'Student',
  'adm.gate.instructorSub': 'Expert accounts cannot access the admin portal. Manage your profile from My Account.',
  'adm.gate.instructorCta': 'Go to my profile',
  'ins.new': 'New expert',
  'ins.stat.rating': 'Rating',
  'ins.stat.students': 'Students',
  'ins.stat.courses': 'Courses',
  'ins.stat.answered': 'Q&A answered',
  'ins.coursesBy': 'Courses by {name}',
  'ins.noCourses': 'No courses yet',
  'ins.noCoursesHint': 'This expert has not published a course yet.',
  'ins.noSlots': 'No consultation slots yet.',
  'ins.consultSub': 'Private session over video call.',
  'insList.title': 'Experts',
  'insList.sub': '{n} curated experts across every field.',
  'insList.search': 'Search name or expertise…',
  'insList.allCategories': 'All fields',
  'insList.empty': 'No experts found',
  'insList.emptyHint': 'Try another keyword or pick a different field.',
  'home.categoriesSub': '{n} fields, one curation standard.',
  'cat.courseCount': '{n} courses',
  'cat.filterSearch': 'Search field…',
  'cat.none': 'No field found',
  'cat.seeAllExperts': 'See all experts',

  // ——— kredit, bagi hasil, video pelajaran, ruang kerja pakar ———
  'vid.title': 'Lesson video',
  'vid.none': 'No video yet',
  'vid.upload': 'Upload video',
  'vid.dropHint': 'drag an MP4 file here',
  'vid.choose': 'Choose file',
  'vid.replace': 'Replace video',
  'vid.remove': 'Remove video',
  'vid.uploading': 'Uploading… {pct}%',
  'vid.finishing': 'Finishing…',
  'vid.ready': 'Video ready',
  'vid.failed': 'Upload failed',
  'vid.retry': 'Try again',
  'vid.cancel': 'Cancel',
  'vid.tooLarge': 'Videos are limited to 2 GB.',
  'vid.wrongType': 'Only MP4 files are supported.',
  'vid.slowStart': 'This video will be slow to start. Re-export it with "faststart" so viewers do not wait.',
  'vid.durationMin': '{n} min',
  'vid.preview': 'Play preview',
  'vid.keepTab': 'Keep this tab open until the upload finishes.',
  'vid.onlyVideoLesson': 'Video upload is only for Video lessons.',
  'price.credits': 'Price (credits)',
  'price.creditsHint': 'What the student pays, in credits.',
  'price.compareCredits': 'Compare-at price (credits)',
  'price.locked': 'Price locked',
  'price.lockedHint': 'The price cannot change once the course is submitted or published. Ask an admin if it must change.',
  'price.creditUnit': 'credits',
  'cur.submit': 'Submit for review',
  'cur.submitting': 'Submitting…',
  'cur.ready': 'Ready to submit',
  'cur.notReady': 'Not ready yet',
  'cur.problems': 'What is still missing',
  'cur.waiting': 'Waiting for admin review',
  'cur.rejectedReason': 'Why it was returned',
  'cur.fixAndResubmit': 'Fix it, then submit again.',
  'pd.title': 'Expert workspace',
  'pd.cardCourses': 'My courses',
  'pd.cardStudents': 'Students',
  'pd.cardCuration': 'Review queue',
  'pd.published': '{n} published',
  'pd.draftCount': '{n} draft',
  'pd.pendingCount': '{n} pending',
  'pd.rejectedCount': '{n} returned',
  'pd.activeStudents': '{n} active',
  'pd.completedStudents': '{n} completed',
  'pd.needsAttention': 'Needs attention',
  'pd.allGood': 'Nothing needs fixing.',
  'pd.recentStudents': 'Recent students',
  'pd.noStudents': 'No students yet.',
  'pd.privacyNote': 'You see names and photos only. Student contacts are not shared.',
  'pd.myCourses': 'My courses',
  'pd.newCourse': 'New course',
  'pd.reorder': 'Reorder',
  'pd.noCourses': 'No courses yet',
  'pd.noCoursesHint': 'Start by creating your first course.',
  'pd.videoReady': '{a}/{b} videos ready',
  'pd.reason.no_lessons': 'No lessons yet',
  'pd.reason.missing_video': 'A video lesson has no video',
  'pd.reason.no_price': 'Price not set',
  'pd.reason.rejected': 'Returned by admin',
  'pd.reason.draft_stale': 'Old draft never submitted',
  'wal.title': 'Credit wallet',
  'wal.balance': 'Credit balance',
  'wal.withdrawable': 'Withdrawable',
  'wal.topup': 'Top up',
  'wal.history': 'Credit history',
  'wal.amount': 'Number of credits',
  'wal.willPay': 'You pay',
  'wal.create': 'Create invoice',
  'wal.manualNote': 'After you pay, an admin confirms it and the credits land in your wallet.',
  'wal.empty': 'No transactions yet.',
  'wal.topupsTitle': 'Top-up invoices',
  'wal.capNote': 'Only commission credits can be cashed out. Topped-up credits are for buying courses.',
  'wal.kind.topup': 'Top-up',
  'wal.kind.purchase': 'Course purchase',
  'wal.kind.commission': 'Commission',
  'wal.kind.withdrawal': 'Withdrawal',
  'wal.kind.adjustment': 'Adjustment',
  'wal.kind.withdrawal_reversal': 'Withdrawal returned',
  'wal.status.pending': 'Awaiting payment',
  'wal.status.paid': 'Paid',
  'wal.status.failed': 'Failed',
  'wal.status.expired': 'Expired',
  'wal.currency': 'Pay in',
  'wal.payWith': 'Payment provider',
  'wal.channel': 'Pay with',
  'wal.suggested': 'Suggested',
  'wal.noGateway': 'No payment method is active yet. Please contact an admin.',
  'wal.minimum': 'Minimum for this method:',
  'wal.continuePay': 'Continue payment',
  'wal.gw.stripe': 'Credit / debit card',
  'wal.gw.doku': 'QRIS, transfer & e-wallet',
  'wal.gw.manual': 'Manual transfer',
  'wal.gwHint.stripe': 'Visa, Mastercard. Charged in ringgit (MYR).',
  'wal.gwHint.doku': 'QRIS, virtual account, OVO, DANA. Charged in rupiah (IDR).',
  'wal.gwHint.manual': 'Direct transfer, confirmed by an admin.',
  'wal.ret.checking': 'Your payment is being checked. Credits arrive automatically once the provider confirms — usually under a minute.',
  'wal.ret.paid': 'Payment received. The credits are already in your wallet.',
  'wal.ret.cancelled': 'Payment cancelled. The invoice is still saved and can be resumed from the list below.',
  'wal.ret.failed': 'Payment did not go through. Nothing was charged; please try again.',
  'aff.title': 'Affiliate',
  'aff.code': 'Your code',
  'aff.link': 'Your link',
  'aff.copy': 'Copy',
  'aff.copied': 'Copied',
  'aff.referred': 'People referred',
  'aff.earned': 'Commission earned',
  'aff.pendingCredits': 'Awaiting payout',
  'aff.sales': 'Sales',
  'aff.recent': 'Recent commission',
  'aff.empty': 'No commission yet.',
  'aff.hint': 'Share this link. Anyone who signs up through it is permanently linked to your account.',
  'aff.permanentNote': 'This link is set once and never changes.',
  'wd.title': 'Payouts',
  'wd.available': 'Available now',
  'wd.held': 'In holding period',
  'wd.feePct': '{pct}% fee',
  'wd.net': 'You receive',
  'wd.request': 'Request payout',
  'wd.min': 'Minimum {n} credits',
  'wd.method': 'How to receive',
  'wd.methodPh': 'e.g. bank transfer to …',
  'wd.history': 'Payout history',
  'wd.empty': 'No payouts yet.',
  'wd.sent': 'Payout request sent',
  'wd.holdNote': 'Commission becomes payable after the holding period. This protects against payment reversals.',
  'wd.status.requested': 'Requested',
  'wd.status.approved': 'Approved',
  'wd.status.paid': 'Paid',
  'wd.status.rejected': 'Rejected',
  'wd.source.instructor': 'Teaching commission',
  'wd.source.affiliate': 'Affiliate commission',
  'wd.source.provider': 'Institution commission',
  'co.payWithCredits': 'Pay with credits',
  'co.yourBalance': 'Your balance',
  'co.creditWallet': 'Credit wallet',
  'co.creditWalletNote': 'Your balance and top-ups live in your The Muslim account.',
  'co.short': '{n} credits short',
  'co.topupFirst': 'Top up first',
  'co.paying': 'Processing…',
  'ams.title': 'Money settings',
  'ams.rate': 'Price of 1 credit',
  'ams.currency': 'Currency',
  'ams.split': 'Revenue split',
  'ams.platform': 'The Muslim',
  'ams.provider': 'Provider',
  'ams.instructor': 'Expert',
  'ams.affiliate': 'Affiliate',
  'ams.mustBe100': 'The total must be exactly 100%.',
  'ams.total': 'Total {n}%',
  'ams.withdrawFee': 'Payout fee (%)',
  'ams.withdrawMin': 'Minimum payout (credits)',
  'ams.hold': 'Holding period (days)',
  'ams.vat': 'VAT',
  'ams.vatOn': 'Enable VAT',
  'ams.vatPct': 'VAT rate (%)',
  'ams.vatPoint': 'Collected at',
  'ams.vatPoint.topup': 'At top-up',
  'ams.vatPoint.purchase': 'At course purchase',
  'ams.vatWarn': 'VAT is off. Turn it on only once the rate and collection point are confirmed.',
  'ams.topupFee': 'Top-up fee (%)',
  'ams.topupFeeFlat': 'Flat top-up fee',
  'ams.example': 'Example: a 10-credit purchase',
  'ams.saved': 'Money settings saved',
  'ams.ch.tab': 'Payment methods',
  'ams.ch.name': 'Method',
  'ams.ch.gateway': 'Provider',
  'ams.ch.feeBps': 'Rate (bps)',
  'ams.ch.feeFlat': 'Flat fee',
  'ams.ch.vat': 'Tax (bps)',
  'ams.ch.effective': 'Effective',
  'ams.ch.on': 'Active',
  'ams.ch.off': 'Inactive',
  'ams.ch.noCode': 'No provider code',
  'ams.ch.empty': 'No payment methods yet.',
  'ams.gross': 'Gross',
  'ams.fee': 'Provider fee',
  'ams.net': 'Net received',
  'ams.markPaid': 'Mark paid',
  'ams.payNow': 'Pay out',
  'ams.rejectWd': 'Reject',
  'nav.wallet': 'Wallet',
  'nav.affiliate': 'Affiliate',
  'admin.myCourses': 'My Courses',
  'admin.money': 'Money Settings',
  'admin.topups': 'Top-ups',
  'admin.withdrawals': 'Payouts',
  'admin.workspaceOnly': 'Expert workspace',
  'adm.gate.instructorCta': 'Go to my workspace',
  'aff.haveCode': 'Have an affiliate code?',
  'aff.enterCode': 'Enter code',
  'aff.apply': 'Apply',
  'aff.applied': 'Affiliate set',
  'aff.onlyBefore': 'A code can only be set before your first purchase.',
  'aff.myReferrer': 'Your affiliate is already set.',

  // ---- kredit: dasbor + buku besar bagi hasil ----
  'adm.dash.creditsMonth': 'Credits this month',
  'adm.dash.credits12': 'Credits, 12 months',
  'adm.dash.credits12sub': 'Paid orders, per month',
  'adm.earn.sub': 'Revenue-share ledger, one row per payee. All values in credits.',
  'adm.earn.total': 'Total credits',
  'adm.earn.col.payee': 'Payee',
  'adm.earn.col.credits': 'Credits',
  'adm.earn.col.payeeType': 'Role',
  'adm.earn.payee.platform': 'Platform',
  'adm.earn.payee.provider': 'Provider',
  'adm.earn.payee.instructor': 'Instructor',
  'adm.earn.payee.affiliate': 'Affiliate',
  'adm.earn.legacy': '{n} legacy rupiah rows are excluded from the total.',
  'adm.earn.unclaimed': 'Unclaimed',
  // Prerequisite & learning path (§21).
  'course.prereqLocked': 'Finish this course first:',
  'course.prereqAdvised': 'Recommended to finish first:',
  'course.prereqGo': 'Open the prerequisite',
  'course.path': 'Learning path',
  'course.pathHint': 'The order the instructor suggests.',
  'course.pathBefore': 'Before this',
  'course.pathNow': 'This course',
  'course.pathNext': 'Next up',
  'adm.course.prereq': 'Prerequisite course',
  'adm.course.prereqNone': 'No prerequisite',
  'adm.course.prereqHint': 'The course that should be finished first. Your own courses only.',
  'adm.course.prereqRequired': 'Must be completed first',
  'adm.course.prereqLocked': 'Students cannot buy this course until they pass the prerequisite.',
  'adm.course.prereqAdvised': 'Shown as advice only. The course stays purchasable.',
  'course.payNote': 'Paid with credits · access opens immediately',
  'adm.coupons.field.valueCredits': 'Fixed discount (credits)',
  'adm.coupons.field.valueCreditsHint': "Used only when the coupon type is 'fixed'. For 'percent', fill the Value field.",

  // --- Curation email notifications ---
  'adm.bc.tab.send': 'Send broadcast',
  'adm.bc.tab.email': 'Automatic email',
  'adm.notif.smtp': 'Email delivery',
  'adm.notif.smtpOn': 'Ready',
  'adm.notif.smtpOff': 'Not configured',
  'adm.notif.smtpFrom': 'Sent from {from}',
  'adm.notif.smtpHint': 'SMTP credentials are not set on the server, so no email will go out even if the list below is filled in. Set SMTP_HOST and SMTP_FROM in the server .env file.',
  'adm.notif.curation': 'Email me when a course is submitted for review',
  'adm.notif.curationHint': 'In-panel notifications are still created when this is off. This adds email, so the review queue does not pile up just because nobody opened the panel.',
  'adm.notif.recipients': 'Recipient addresses',
  'adm.notif.addEmail': 'Add address',
  'adm.notif.removeEmail': 'Remove address',
  'adm.notif.noRecipients': 'No addresses yet. With no recipients, no email can be sent.',
  'adm.notif.decision': 'Notify the expert when their course is approved or rejected',
  'adm.notif.decisionHint': 'Sent to the account email of the course owner. Rejections include the reason.',
  'adm.notif.save': 'Save settings',
  'adm.notif.test': 'Send test email',
  'adm.notif.testSent': 'Test email sent to {n} address(es).',
  'adm.notif.testFailed': 'Test email failed to send.',
}
